import React from 'react';

export default class Swipeable extends React.Component {
  props: {
    onSwiped: Function,
    onSwiping: Function,
    onSwipingUp: Function,
    onSwipingRight: Function,
    onSwipingDown: Function,
    onSwipingLeft: Function,
    onSwipedUp: Function,
    onSwipedRight: Function,
    onSwipedDown: Function,
    onSwipedLeft: Function,
    flickThreshold: number,
    delta: number,
  }

  static defaultProps = {
    flickThreshold: 0.6,
    delta: 10,
  };

  getStartingState() {
    return {
      x: null,
      y: null,
      swiping: false,
      start: 0,
    };
  }

  constructor(props) {
    super(props);
    this.state = this.getStartingState();
  }

  calculatePos = (e) => {
    const x = e.changedTouches[0].clientX;
    const y = e.changedTouches[0].clientY;

    const xd = this.state.x - x;
    const yd = this.state.y - y;

    const axd = Math.abs(xd);
    const ayd = Math.abs(yd);

    return {
      deltaX: xd,
      deltaY: yd,
      absX: axd,
      absY: ayd,
    };
  }

  touchStart = (e) => {
    if (e.touches.length > 1) {
      return;
    }
    this.setState({
      start: Date.now(),
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
      swiping: false,
    });
  }

  touchMove = (e) => {
    if (!this.state.x || !this.state.y || e.touches.length > 1) {
      return;
    }

    let cancelPageSwipe = false;
    const pos = this.calculatePos(e);

    if (pos.absX < this.props.delta && pos.absY < this.props.delta) {
      return;
    }

    if (this.props.onSwiping) {
      this.props.onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY);
    }

    if (pos.absX > pos.absY) {
      if (pos.deltaX > 0) {
        if (this.props.onSwipingLeft) {
          this.props.onSwipingLeft(e, pos.absX);
          cancelPageSwipe = true;
        }
      } else {
        if (this.props.onSwipingRight) {
          this.props.onSwipingRight(e, pos.absX);
          cancelPageSwipe = true;
        }
      }
    } else {
      if (pos.deltaY > 0) {
        if (this.props.onSwipingUp) {
          this.props.onSwipingUp(e, pos.absY);
          cancelPageSwipe = true;
        }
      } else {
        if (this.props.onSwipingDown) {
          this.props.onSwipingDown(e, pos.absY);
          cancelPageSwipe = true;
        }
      }
    }

    this.setState({ swiping: true });

    if (cancelPageSwipe) {
      e.preventDefault();
    }
  }

  touchEnd = (ev) => {
    if (this.state.swiping) {
      const pos = this.calculatePos(ev);

      const time = Date.now() - this.state.start;
      const velocity = Math.sqrt(pos.absX * pos.absX + pos.absY * pos.absY) / time;
      const isFlick = velocity > this.props.flickThreshold;

      this.props.onSwiped && this.props.onSwiped(
        ev,
        pos.deltaX,
        pos.deltaY,
        isFlick,
      );

      if (pos.absX > pos.absY) {
        if (pos.deltaX > 0) {
          this.props.onSwipedLeft && this.props.onSwipedLeft(ev, pos.deltaX, isFlick);
        } else {
          this.props.onSwipedRight && this.props.onSwipedRight(ev, pos.deltaX, isFlick);
        }
      } else {
        if (pos.deltaY > 0) {
          this.props.onSwipedUp && this.props.onSwipedUp(ev, pos.deltaY, isFlick);
        } else {
          this.props.onSwipedDown && this.props.onSwipedDown(ev, pos.deltaY, isFlick);
        }
      }
    }
    this.setState(this.getStartingState());
  }

  render() {
    return (
      <div
        onTouchStart={this.touchStart}
        onTouchMove={this.touchMove}
        onTouchEnd={this.touchEnd}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/client/utils/Swipeable.js